import script from "./AnnotationToolbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnotationToolbar.vue?vue&type=script&setup=true&lang=ts"

import "./AnnotationToolbar.vue?vue&type=style&index=0&id=b4ed2b7a&scoped=true&lang=css"
import "./AnnotationToolbar.vue?vue&type=style&index=1&id=b4ed2b7a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4ed2b7a"]])

export default __exports__